import { graphql } from 'react-relay';
export const GlobalOperationsUserPermissionTypeQuery = graphql`
	query GlobalOperationsUserPermissionTypeQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				permissionType
			}
		}
	}
`;
